class WebGPUBinding {
  constructor() {
    let name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    this.name = name;
    this.visibility = null;
    this.type = null; // read-only

    this.isShared = false;
  }

  setVisibility(visibility) {
    this.visibility = visibility;
  }

}

export default WebGPUBinding;